import { useEffect } from "preact/hooks";

const SITE = "Elwood CMS";

// Updates document.title to `${title} · ${SITE}` while the caller is mounted.
// Pass an empty string to show the bare site name. Pass null / undefined to
// opt out entirely (e.g. PageHeader with a JSX title — the screen sets it
// manually). We don't restore the previous title on unmount; the next
// screen's hook overwrites it, and restoring would flash an outdated title
// between route transitions in preact-iso (cleanup runs before next mount).
export function useDocumentTitle(title: string | null | undefined) {
  useEffect(() => {
    if (title == null) return;
    document.title = title ? `${title} · ${SITE}` : SITE;
  }, [title]);
}
